module.exports = __webpack_public_path__ + "static/media/perimbaba.39c37ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/perimbaba.png
// module id = 480
// module chunks = 0